const localhost = 'http://localhost:3001'
const api = 'https://hd-chat-api-5203dcc449f5.herokuapp.com'
export const API = api;